var _clipPath, _clipPath2, _clipPath3, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBleu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 333.844 123.844",
    viewBox: "5 5 91 91.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.895493 2.626982h118.32153v118.32153h-118.32153z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.609019 2.641801h118.52519v118.52519h-118.52519z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.609019 2.641801h118.52519v118.52519h-118.52519z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#c)",
    cx: 66.925003,
    cy: 62.194,
    fill: "#004e9f",
    r: 45.731998,
    transform: "translate(-16.563888 -11.479409)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m47.875 77.11 30.148 29.455c19.127-4.77 33.491-21.578 34.567-41.915l-11.751-11.486z",
    opacity: 0.2,
    transform: "translate(-16.563888 -11.479409)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    fill: "#fff",
    transform: "translate(-16.563888 -11.479409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.965 51.273-22.835 5.166 2.489 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.228 51.184 22.791 5.199-2.488 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.261 64.761 10.236-4.272-10.236-15.843v-.082l-.031.039-.03-.039v.082l-10.677 15.687 10.677 4.428v.025l.03-.015.031.015z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.23 67.326-33.607-14.162 14.252 23.946h19.325.061 19.325l14.253-23.946z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBleu);
export default __webpack_public_path__ + "static/media/logo_bleu.c22dba0daa4f8b39cc8322b8fc412c4d.svg";
export { ForwardRef as ReactComponent };